import { DashboardRoutes } from "@/router/constant";
import { matchPath, useLocation } from "react-router-dom";

export function useSelectedTab(): string {
  const location = useLocation();
  const ROUTES = {
    settlement: DashboardRoutes.settlement.root.url,
    mySale: DashboardRoutes.mySale.root.url,
    myShop: DashboardRoutes.myShop.root.url,
    connections: DashboardRoutes.connections.root.url,
    home: DashboardRoutes.home.root.url,
    // platform: DashboardRoutes.platform.root.url,
    user: DashboardRoutes.user.root.url,
    profile: DashboardRoutes.profile.root.url,
    settings: DashboardRoutes.settings.root.url,
    register: DashboardRoutes.register.root.url,
    digitalAccount: DashboardRoutes.digitalAccount.root.url,
  };

  const matchedRoute = Object.values(ROUTES).find((microPaths) => {
    const matchedPath = matchPath({ end: false, path: microPaths }, location.pathname);
    return Boolean(matchedPath);
  });

  const selectedPath = matchedRoute || location.pathname;
  return selectedPath;
}
